<template>
  <nav class="py-3">
    <AppSubmenu
      :items="model"
      :claims="claims"
      :user-email="userEmail"
      :root="true"
      @menuitem-click="onMenuItemClick"
    />
  </nav>
</template>

<script setup>
import { computed } from 'vue';
import AppSubmenu from './AppSubmenu';
import useUser from '@/composables/useUser';

defineProps({ model: Array });

const emit = defineEmits(['menuitem-click']);
const { user, claims } = useUser();
const userEmail = computed(() => (user.value?.email || '').toLowerCase());

const onMenuItemClick = (event) => {
  emit('menuitem-click', event);
};
</script>
